import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={'90%'}
    height={31}
    viewBox="0 0 642 31"
    fill="none"
    {...props}
  >
    <g clipPath="url(#anab)">
      <path
        stroke="url(#bnab)"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="m25.004 14.778 591.001.003"
      />
      <path
        fill="url(#cnab)"
        stroke="url(#dnab)"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="M334.058 15.03c-7.483-.575-13.454-6.547-14.029-14.03-.575 7.483-6.546 13.454-14.029 14.03 7.483.574 13.454 6.546 14.029 14.029.575-7.483 6.547-13.454 14.03-14.03h-.001Z"
      />
    </g>
    <defs>
      <linearGradient
        id="bnab"
        x1={48.506}
        x2={579.006}
        y1={39.898}
        y2={38.898}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.033} stopColor="#9B8876" stopOpacity={0} />
        <stop offset={0.495} stopColor="#9B8876" />
        <stop offset={0.981} stopColor="#9B8876" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="cnab"
        x1={320.029}
        x2={320.029}
        y1={1}
        y2={29.059}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#ADA23C" stopOpacity={0} />
        <stop offset={0.495} stopColor="#CEC88B" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="dnab"
        x1={307.153}
        x2={333.676}
        y1={12.916}
        y2={17.913}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C866B" />
        <stop offset={0.29} stopColor="#7D7649" />
        <stop offset={0.505} stopColor="#DDCFA2" />
        <stop offset={0.69} stopColor="#A59A87" />
        <stop offset={0.895} stopColor="#8C866B" />
      </linearGradient>
      <clipPath id="anab">
        <path fill="#fff" d="M0 0h642v31H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
